import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { DatePipe } from '@angular/common';
import { ReportsService } from '../../../../services/reports.service';
import { PrintService } from '../../../../services/print-service';

@Component({
    selector: 'page-show-sheets-report',
    templateUrl: 'report-show-sheets.html'

})
export class ShowSheetsReport {
    @Input('rodeo') rodeo: Rodeo;

    selectedRodeoEvent: RodeoEvent;

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;
    shortRound: boolean;

    roundArray: any[];
    runResultArray: any[];

    constructor(private nav: NavController, private navParams: NavParams, private datePipe: DatePipe,
        private printService: PrintService, private reportService: ReportsService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        if (!this.shortRound)
            this.shortRound = navParams.get("shortRound");

        if (!this.selectedRodeoEvent)
            this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');

        if (this.rodeo && this.selectedRodeoEvent)
            this.printing = true;

        if (this.printing) {
            this.load();
        }
    }

    load() {
        if (!this.printing) {
            this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];
        }

        this.updateRodeoEvent();

        this.documentTitle = this.rodeo.name + " - " + 'Sheets';
        this.dataLoaded = true;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    updateRodeoEvent() {
        (this.selectedRodeoEvent as any).runs = this.getRuns(this.selectedRodeoEvent);

        this.roundArray = [];

        for (let i = 1; i <= this.selectedRodeoEvent.rounds + (this.selectedRodeoEvent.shortGo ? 1 : 0); i++) {
            this.roundArray.push("Rd " + i);

            if (i > 1)
                this.roundArray.push("ToT " + i);
        }
    }

    getRuns(rodeoEvent: RodeoEvent) {
        let runs = [];
        let selectedSchedule = this.selectedRodeoEvent.schedules[0];

        if (selectedSchedule.scheduleGroupId && selectedSchedule.scheduleGroupId != 0 && !this.shortRound) {
            runs = this.rodeo.rodeoEvents.flatMap(x => x.schedules)
                .filter(x => x.scheduleGroupId == selectedSchedule.scheduleGroupId).flatMap(x => x.runs);
        } else {
            runs = selectedSchedule.runs;
        }

        let shortRoundRuns = runs.filter(x => x.round > rodeoEvent.rounds);

        if (this.shortRound)
            runs = runs.filter(x => shortRoundRuns.some(y => y.runIdentifier == x.runIdentifier));

        this.runResultArray = [];

        if (runs.length > 0) {
            if (this.shortRound) {
                runs.sort((n1, n2) => {
                    if (n1.number > n2.number)
                        return -1;
                    else
                        return 1;
                })

            } else {
                runs.sort((n1, n2) => {
                    if (n1.number < n2.number)
                        return -1;
                    else if (n1.number > n2.number)
                        return 1;
                })
            }

            let matchingBackNumbers = null;

            if (this.rodeo.backNumberConfigs && this.rodeo.backNumberConfigs.length > 0) {
                matchingBackNumbers = this.rodeo.backNumbers.filter(x => x.eventType == this.selectedRodeoEvent.eventType);

                if (matchingBackNumbers.length == 0)
                    matchingBackNumbers = this.rodeo.backNumbers.filter(x => !x.eventType);
            }

            runs.forEach(run => {
                let index = run.round > 2 ? run.round + (run.round - 2) : run.round;

                if (run.rodeoEventScheduleId != selectedSchedule.id)
                    (run as any).showAsterisk = true;
                else
                    (run as any).showAsterisk = false;

                if (!this.runResultArray[run.runIdentifier])
                    this.runResultArray[run.runIdentifier] = [];

                this.runResultArray[run.runIdentifier][index] = rodeoEvent.configuration.runs.scoreValue ? (run.noTime ? "NS" : run.score) : (run.noTime ? "NT" : run.time);

                if (matchingBackNumbers != null) {
                    var backNumberObj = matchingBackNumbers.filter(x => (this.rodeo.backNumberConfigs[0].byHorse ? x.horseId == run.horseOneId : x.accountId == run.contestantOneId))[0];
                    if (backNumberObj)
                        (run as any).contestantOneBackNumber = backNumberObj.number;

                    if (run.contestantTwo != null) {
                        backNumberObj = matchingBackNumbers.filter(x => (this.rodeo.backNumberConfigs[0].byHorse ? x.horseId == run.horseTwoId : x.accountId == run.contestantTwoId))[0];

                        if (backNumberObj)
                            (run as any).contestantTwoBackNumber = backNumberObj.number;
                    }
                }

                if (run.round > 1 && run.done)
                    this.runResultArray[run.runIdentifier][index + 1] = rodeoEvent.configuration.runs.scoreValue ? run.totalScore : run.totalTime;
            });

            return runs.filter(x => this.shortRound ? x.round > rodeoEvent.rounds : x.round == 1);
        } else
            return [];
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    shouldWriteDragLine(rodeoEvent, run, runIndex) {
        if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= rodeoEvent.runs.length || rodeoEvent.eventType != 'BarrelRacing')
            return false;

        let nextRun = rodeoEvent.runs[runIndex + 1];

        let lastDragCount = Math.floor(+run.number / +rodeoEvent.dragEvery);
        let currentDragCount = Math.floor(+nextRun.number / +rodeoEvent.dragEvery);

        if ((currentDragCount > lastDragCount && +nextRun.number % +rodeoEvent.dragEvery != 0) || +run.number % +rodeoEvent.dragEvery == 0)
            return true;

        return false;
    }

    shouldWriteBigDragLine(rodeoEvent, run, runIndex) {
        if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= rodeoEvent.runs.length || rodeoEvent.eventType != 'BarrelRacing')
            return false;

        let nextRun = rodeoEvent.runs[runIndex + 1];

        let lastBigDragCount = Math.floor(+run.number / +rodeoEvent.bigDragEvery);
        let currentBigDragCount = Math.floor(+nextRun.number / +rodeoEvent.bigDragEvery);

        if ((currentBigDragCount > lastBigDragCount && +nextRun.number % +rodeoEvent.bigDragEvery != 0) || +run.number % +rodeoEvent.bigDragEvery == 0)
            return true;

        return false;
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 1);
    }

    async print() {
        this.printing = true;
        await this.printService.print(this.documentTitle);
        this.printing = false;
    }

    getHorseAge(birthDate) {
        const birthdate = new Date(birthDate);
        const today = new Date();
        const diffYear = today.getFullYear() - birthdate.getFullYear();
        const diffMonths = today.getMonth() - birthdate.getMonth();
        return `${diffYear}y ${diffMonths}m`;
    }


    download() {
        const report = [];
        const rodeoEvents = this.rodeo.rodeoEvents;
        rodeoEvents.forEach((rodeoEvent: any) => {
            if (rodeoEvent.runs) {
                rodeoEvent.runs.forEach(run => {
                    report.push(this.createReportItem(rodeoEvent, run, run.contestantOne, run.horseOne));
                    if (rodeoEvent.eventType == 'TeamRoping') {
                        report.push(this.createReportItem(rodeoEvent, run, run.contestantTwo, run.horseTwo, 2));
                    }
                });
            }
        });
        this.reportService.exportToCsv(report, `${this.rodeo.name} - ${this.selectedRodeoEvent.displayName}`);
    }

    private createReportItem(rodeoEvent, run, contestant, horse, horseNum = 1) {
        let item = {
            "Rodeo Event": `${rodeoEvent.displayName}`,
            Run: run.number,
            Contestant: contestant ? `${contestant.firstName} ${contestant.lastName}` : '',
            City: contestant ? contestant.city : '',
            State: contestant ? contestant.state : ''
        } as any;

        const isRoughStock = this.isRoughStock(rodeoEvent);
        if (!isRoughStock) {
            item["Horse"] = horse ? horse.name : 'Horse ' + horseNum;
            item["Horse AQHA Id"] = horse ? horse.aqhaId : '';
            item["Horse Age"] = horse && horse.birthDate ? this.getHorseAge(horse.birthDate) : '';
            item["Horse Sex"] = horse ? horse.sex : '';
            item["Horse Sire"] = horse && horse.sire ? horse.sire.name : '';
            item["Horse Dam"] = horse && horse.dam ? horse.dam.name : '';
            item["Horse Dam Sire"] = horse && horse.dam && horse.dam.sire ? horse.dam.sire.name : '';
            item["Horse Owner"] = horse && horse.owner ? horse.owner.name : '';
            item["Horse Breeder"] = horse && horse.breeder ? horse.breeder.name : '';
            item["TO"] = run.turnedOut ? 'X' : '';
            item["Time"] = run.turnedOut ? 'TO' : run.time;
        }


        if (isRoughStock) {
            item["Stock #"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Ride"] = run.turnedOut ? 'TO' : run.score;
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Subtotal"] = run.time
            item["Total"] = run.totaltime
        } else if (rodeoEvent.eventType !== 'BarrelRacing') {
            item["Stock"] = run.livestock ? run.livestock.brand + ' ' + run.livestock.name : '';
            item["Penalty"] = run.penaltyTime;
            item["Total Time"] = run.totalTime;
        }

        return item;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-show-sheets.ts